'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;
exports.init = init;
exports.getCUInfo = getCUInfo;
exports.getCUMajor = getCUMajor;
var t = {
    GET_CU_INFO: 'bp/subject/cu/GET_CU_INFO',
    GET_CU_INFO_SUCCESS: 'bp/subject/cu/GET_CU_INFO_SUCCESS',
    GET_CU_INFO_DETAIL: 'bp/subject/cu/GET_CU_INFO_DETAIL',

    GET_CU_MAJOR: 'bp/subject/cu/GET_CU_MAJOR',
    GET_CU_MAJOR_SUCCESS: 'bp/subject/cu/GET_CU_MAJOR_SUCCESS',
    GET_CU_MAJOR_FAIL: 'bp/subject/cu/GET_CU_MAJOR_FAIL',

    SET_CU_INFO: 'bp/subject/cu/SET_CU_INFO'
};

var initialState = {
    cu: {},
    majorSubjects: [],
    loading: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case t.GET_CU_INFO_SUCCESS:
            if (!action.result.data.success) {
                return state;
            }
            return _extends({}, state, {
                cu: action.result.data.data
            });
        case t.GET_CU_MAJOR:
            return _extends({}, state, {
                loading: true
            });
        case t.GET_CU_MAJOR_SUCCESS:
            if (!action.result.data.success) {
                return _extends({}, state, {
                    loading: false
                });
            }
            return _extends({}, state, {
                majorSubjects: action.result.data.data,
                loading: false
            });
        case t.GET_CU_MAJOR_FAIL:
            return _extends({}, state, {
                loading: false
            });
        case t.SET_CU_INFO:
            return _extends({}, state, {
                cu: action.cu
            });
        default:
            return state;
    }
}

function init(cu) {
    return function (dispatch, getState) {
        dispatch({
            type: t.SET_CU_INFO,
            cu: cu
        });
        dispatch(getCUInfo(cu.hashId));
        //dispatch(getCUMajor(selectedSubjects, cu.hashId, year));
    };
}

function getCUInfo(schoolHashId) {
    return {
        types: [t.GET_CU_INFO, t.GET_CU_INFO_SUCCESS, t.GET_CU_INFO_DETAIL],
        promise: function () {
            function promise(client) {
                return client.get('/api/subject/cu_info?schoolHashId=' + schoolHashId);
            }

            return promise;
        }()
    };
}

function getCUMajor(selectedSubjects, schoolHashId, year) {
    var subjectIds = selectedSubjects.map(function (row) {
        return row.id;
    });
    return {
        types: [t.GET_CU_MAJOR, t.GET_CU_MAJOR_SUCCESS, t.GET_CU_MAJOR_FAIL],
        promise: function () {
            function promise(client) {
                return client.post('/api/subject/cu_subject_majors', {
                    "subjectIds": subjectIds,
                    "schoolHashId": schoolHashId,
                    "year": year
                });
            }

            return promise;
        }()
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/reducers/subject/subjectCUDetail.js
// module id = 453
// module chunks = 0